import axiosInstance from './AxiosInstance';


// Approve exception
export const statusUpdate = async (po_exception_id, payload) => {
  try {
    const response = await axiosInstance.put(
      `/exceptions/status/${po_exception_id}`,
      payload // Send payload directly
    );
  
    return response.data;
  } catch (error) {
    console.error("Error approving exception:", error);
    throw error;
  }
};

// Delete exception
export const deleteException = async (po_exception_id) => {
  try {
    const response = await axiosInstance.delete(`/exceptions/${po_exception_id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting exception:", error);
    throw error;
  }
};

// Exception update
export const exceptionUpdate = async (po_exception_id, payload) => {
  try {
    const response = await axiosInstance.put(
      `/exceptions/status/${po_exception_id}`,
      payload // Send payload directly
    );
    return response.data;
  } catch (error) {
    console.error("Error approving exception:", error);
    throw error;
  }
};

// Update PO exception
export const updatePoException = async (po_exception_id, payload) => {
  console.log("API Function Called with ID:", po_exception_id, "Payload:", payload);
  try {
    const response = await axiosInstance.put(
      `/exceptions/${po_exception_id}`, // Update API URL
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating exception:", error);
    throw error;
  }
};
